import { useEffect, useContext, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import { InputSelect } from "../components/formComponents/inputSelect";
import { mensajeSimple } from "../components/ui/sweetAlerts";
import { ModalContractuales } from "./modalForm/modalForm";
import { DataContext } from "../contextData/contextData";
import { UseModalForm } from "./modalForm/useModalForm";
import { useIndex } from "./useIndex";
import { Icono } from "../components/ui/Iconos";
import { formatRUT } from "../utils/funciones";

export const Index = props => {
  const { modulo } = props;
  const { uno, setNombreMenuu } = useContext(DataContext);
  const { traerData, filtrarUno, arrData, objTipoContrato, formatFecha } = useIndex();
  const { visible, hideModal, dataModal, procesoSelected } = UseModalForm();

  useEffect(() => {
    traerData();
    setNombreMenuu("Iniciar solicitud");
  }, []);
  useLayoutEffect(() => {
    filtrarUno();
  }, []);

  return (
    <>
      <ModalContractuales data={dataModal} show={visible} hideModal={hideModal} cambioSelected={procesoSelected} />
      <div className="d-flex align-items-center flex-column py-3">
        <div className="col col-11 col-lg-10 col-xl-10">
          <div
            className="bg-white mb-4"
            style={{
              borderRadius: "8px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
              border: "1px solid #e0e0e0",
              position: "relative",
              zIndex: 5,
            }}
          >
            {/* Header Selector Colaborador */}
            <div className="d-flex flex-row justify-content-between align-items-center p-3 px-4">
              <span className="fw-bold text-dark m-0 align-self-center" style={{ fontSize: "18px", lineHeight: "1" }}>Seleccionar Colaborador</span>
              <div className="d-flex align-items-center" style={{ width: "50%", maxWidth: "500px" }}>
                <InputSelect
                  label="xxx"
                  placeholder="--Seleccione colaborador--"
                  llave_texto="REEO_NOMBRE_COMPLETO"
                  llave_valor="REEO_CODIGO_SAP"
                  arr={arrData}
                  ejecute={filtrarUno}
                  id="select_Colaborador"
                  clases="w-100"
                />
              </div>
            </div>

            {/* Tabla Colaborador Seleccionado */}
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ borderCollapse: "collapse", tableLayout: "fixed", width: "100%" }}>
                <thead>
                  <tr style={{ backgroundColor: "#2472BA", color: "#ffffff" }}>
                    <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "13%" }}>RUT</th>
                    <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "12%" }}>ID PERSONAL</th>
                    <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "12%" }}>POS. ACTUAL</th>
                    <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "27%" }}>CARGO ACTUAL</th>
                    <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "12%" }}>JORNADA/PHTD</th>
                    <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "12%" }}>FECHA ALTA</th>
                    <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "12%" }}>TIPO CONTRATO</th>
                  </tr>
                </thead>
                <tbody id="body-tabla">
                  {uno !== undefined ? (
                    <tr style={{ fontSize: "13.5px", color: "#333", backgroundColor: "#fff", height: "48px" }}>
                      <td className="py-3 px-3 border-0 text-truncate">{formatRUT(uno.REEO_RUT)}</td>
                      <td className="py-3 px-3 border-0 text-truncate">{uno.REEO_CODIGO_SAP}</td>
                      <td className="py-3 px-3 border-0 text-truncate">{uno.REEO_CODIGO_POSICION}</td>
                      <td className="py-3 px-3 border-0 text-truncate" title={uno.estructura?.MOES_DESCRIPCION_POSICION}>{uno.estructura?.MOES_DESCRIPCION_POSICION}</td>
                      <td className="py-3 px-3 border-0 text-truncate">{uno.REEO_PLAN_HORARIO}</td>
                      <td className="py-3 px-3 border-0 text-truncate">{formatFecha(uno.REEO_FECHA_INICIO_CONTRATO)}</td>
                      <td className="py-3 px-3 border-0 text-truncate">{objTipoContrato[uno.REEO_TIPO_CONTRATO]}</td>
                    </tr>
                  ) : (
                    <tr style={{ backgroundColor: "#fff", height: "48px" }}>
                      <td colSpan={7} className="py-3 px-3 border-0 text-center text-muted fw-bold" style={{ fontSize: "13.5px" }}>
                        Aún no se selecciona colaborador
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Tarjetas de Opciones de Cambios Contractuales */}
        {uno !== undefined && (
          <div className="col col-11 col-lg-10 col-xl-10">
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3">
              {["3"].includes(modulo) ? (
                <div className="w-100 d-flex justify-content-center">
                  <div className="col-12 col-sm-8 col-md-6 col-lg-3">
                    <div
                      className="card-opcion bg-white p-3 d-flex align-items-center gap-3 h-100"
                      style={{
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                        border: "1px solid #e2e8f0",
                        cursor: "pointer",
                        transition: "transform 0.15s ease, box-shadow 0.15s ease",
                      }}
                      onClick={() => hideModal(5)}
                    >
                      <Icono iconName="desvinculacion" />
                      <span className="fw-bold" style={{ fontSize: "13.5px", color: "#2d3748", lineHeight: "1.2" }}>
                        Iniciar desvinculación
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {/* Opción 1: Cambio de Cargo */}
                  <div className="col">
                    <div
                      className="card-opcion bg-white p-3 d-flex align-items-center gap-3 h-100"
                      style={{
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                        border: "1px solid #e2e8f0",
                        cursor: "pointer",
                        transition: "transform 0.15s ease, box-shadow 0.15s ease",
                      }}
                      onClick={() => hideModal(1)}
                    >
                      <Icono iconName="cambioCargo" />
                      <span className="fw-bold" style={{ fontSize: "13.5px", color: "#2d3748", lineHeight: "1.2" }}>
                        Cambio de Cargo (SAP & Temporis)
                      </span>
                    </div>
                  </div>

                  {/* Opción 2: Cambio de Unidad */}
                  <div className="col">
                    <div
                      className="card-opcion bg-white p-3 d-flex align-items-center gap-3 h-100"
                      style={{
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                        border: "1px solid #e2e8f0",
                        cursor: "pointer",
                        transition: "transform 0.15s ease, box-shadow 0.15s ease",
                      }}
                      onClick={() => hideModal(2)}
                    >
                      <Icono iconName="cambioUnidad" />
                      <span className="fw-bold" style={{ fontSize: "13.5px", color: "#2d3748", lineHeight: "1.2" }}>
                        Cambio de Unidad (Temporis)
                      </span>
                    </div>
                  </div>

                  {/* Opción 3: Cambio de Instalación */}
                  <div className="col">
                    <div
                      className="card-opcion bg-white p-3 d-flex align-items-center gap-3 h-100"
                      style={{
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                        border: "1px solid #e2e8f0",
                        cursor: "pointer",
                        transition: "transform 0.15s ease, box-shadow 0.15s ease",
                      }}
                      onClick={() => hideModal(3)}
                    >
                      <Icono iconName="cambioInstalacion" />
                      <span className="fw-bold" style={{ fontSize: "13.5px", color: "#2d3748", lineHeight: "1.2" }}>
                        Cambio de Instalación
                      </span>
                    </div>
                  </div>

                  {/* Opción 4: Actualización Estatus */}
                  <div className="col">
                    <div
                      className={`card-opcion p-3 d-flex align-items-center gap-3 h-100 ${
                        ["01"].includes(uno["REEO_TIPO_CONTRATO"]) ? "card-opcion-disabled" : "bg-white"
                      }`}
                      style={{
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                        border: "1px solid #e2e8f0",
                        cursor: ["01"].includes(uno["REEO_TIPO_CONTRATO"]) ? "not-allowed" : "pointer",
                      }}
                      onClick={() => {
                        if (["01"].includes(uno["REEO_TIPO_CONTRATO"])) {
                          mensajeSimple("info", "Este colaborador(a) posee Contrato Indefinido", 2300);
                          return;
                        }
                        hideModal(4);
                      }}
                    >
                      <Icono iconName="cambioEstatus" color={["01"].includes(uno["REEO_TIPO_CONTRATO"]) ? "#9E9E9E" : "#1877F2"} />
                      <div className="d-flex flex-column gap-1">
                        <span
                          className="fw-bold"
                          style={{
                            fontSize: "13.5px",
                            color: ["01"].includes(uno["REEO_TIPO_CONTRATO"]) ? "#64748b" : "#2d3748",
                            lineHeight: "1.25",
                          }}
                        >
                          Estatus contrato de trabajo
                          <br />
                          (Renovación Plazo Fijo e Indefinido)
                        </span>
                        {["01"].includes(uno["REEO_TIPO_CONTRATO"]) && (
                          <span
                            style={{
                              backgroundColor: "#e2e8f0",
                              color: "#475569",
                              border: "1px solid #cbd5e1",
                              borderRadius: "4px",
                              fontSize: "11px",
                              fontWeight: "600",
                              padding: "2px 8px",
                              width: "fit-content",
                            }}
                          >
                            No disponible
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

Index.propTypes = {
  modulo: PropTypes.string,
};
